module.exports = __webpack_public_path__ + "img/whats-new-15_en.3023787.jpg";